<div *ngIf="tableConfig && tableConfig.detailType === 'table'">
  <app-resource-table
    #detailTable
    [config]="tableConfig.detailTableConfig"
  ></app-resource-table>
</div>
<div *ngIf="tableConfig && tableConfig.detailType === 'component'">
  <ng-container appDynamicContainer></ng-container>
</div>
